module.exports = __webpack_public_path__ + "static/img/center02.0ad401e7.png";